exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.success[data-v-a703435a] {\n  background-color: rgba(0, 152, 35, 0.41);\n  border-radius: 5px\n}\n", ""]);

// exports
